import Main from "./Main.js";
import Scene from "./Scene.js";
export default class Wcustom {

	constructor(hs, parms, ct, lDaFuori) {
		this.hs = hs;
		this.ct = ct;
		this.parms = parms;
		this.clips = new Array();
		this.lDaFuori = lDaFuori;

	}

	init() {
		/*let track = new Object();
		track.action = "clicked-hotspot";
		track.hotspot = this.hs.kind
		track.testo_it = this.hs.testo_it
		//console.log(this.hs)
		Main.tracking(track);*/
		if (this.hs.tipo == "linkext") {
			if (this.lDaFuori) {
				setTimeout(jQuery.proxy(this.openWindow, this), 1000);
			} else {
				this.openWindow();
			}
		} else {
			if ((this.hs.tipo == "scendigiuqui") || (this.hs.tipo == "salisuqui") || (this.hs.tipo == "exit") || (this.hs.tipo == "enter") || (this.hs.tipo == "goon") || (this.hs.tipo == "arrow_down_left") || (this.hs.tipo == "arrow_down_right") || (this.hs.tipo == "arrow_up_left") || (this.hs.tipo == "arrow_up_right")) {
				Scene.gotoScene("" + this.hs.InfoJson.iframe_url);
			} else {
				document.location.href = this.hs.InfoJson.iframe_url;
			}
		}
	}


	openWindow() {
		window.open(this.hs.InfoJson.iframe_url, "_blank")
	}

}
Wcustom.ENUM = 0;